/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoPhoneNumberWarning implements angular.IDirective {
        restrict = "E";
        scope = {
            countryCode: "=",
            phoneNumber: "=",
            firstName: "=",
            lastName: "=",
            middleName: "=",
            entityId: "=",
            disabled: "=ngDisabled",
            abortAction: "&",
            context: "=",
            flagPropName: "@"
        }

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModelCtrl: angular.INgModelController) => {
            let localClientSearchOnly = this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.localClientSearchOnly;
            let ds = this.dataService;
            let modalService = this.modalService;
            let validationHistory = [];
            let numCharsToCheck = 3;

            scope.$watch('phoneNumber', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    checkWarning();
                }
            });

            scope.$watch('firstName', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    checkWarning();
                }
            });

            scope.$watch('lastName', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    checkWarning();
                }
            });

            scope.$watch('disabled', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    validationHistory = [];
                }
            });

            function checkWarning() {
                if (!scope.phoneNumber) {
                    return;
                }

                if (scope.context && scope.context[scope.flagPropName]) {
                    return;
                }

                let unformatedPhoneNumber = scope.phoneNumber.replace(/\D/g, '');
                let middleNameEval = (scope.middleName ? scope.middleName : 'null');
                var phoneInput = document.querySelector('#phone');
                var isPhoneInputValid = phoneInput["validity"].valid;
                if (!scope.disabled &&
                    scope.firstName &&
                    scope.firstName.length >= numCharsToCheck &&
                    scope.lastName &&
                    scope.lastName.length > 0 &&
                    isPhoneInputValid &&
                    !_.contains(validationHistory, scope.firstName.substring(0, numCharsToCheck) + scope.lastName + scope.countryCode + unformatedPhoneNumber + middleNameEval)) {

                    var clientRequest =
                    {
                        "pageNumber": 0,
                        "itemsPerPage": 1,
                        "criteria": {
                            "includeActive": true,
                            "view": 2,
                            "coSearchType": null,
                            "coBusinessTypeId": null,
                            "coFilterByLocationId": null,
                            "coSearchResultFilter": 0,
                            "location": null,
                            "businessType": null,
                            "maintenanceMode": true,
                            "countryCode": scope.countryCode,
                            "includeInactive": false,
                            "includeDeleted": false,
                            "isGlobal": !localClientSearchOnly,
                            "filter": "",
                            "phoneFull": unformatedPhoneNumber,
                            "firstName": scope.firstName,
                            "lastName": scope.lastName,
                            "excludeIdList" : [scope.entityId]
                        },
                        "sortBy": null,
                        "sortDirection": 0
                    };
                    ds.customMethodData("/api/Client/List", "POST", clientRequest)
                        .then(data => {

                            validationHistory.push(scope.firstName.substring(0, numCharsToCheck) + scope.lastName + scope.countryCode + unformatedPhoneNumber + middleNameEval);

                            if (data.data
                                && data.data.length >= 1
                                && data.data[0].firstName.toLowerCase() == scope.firstName.toLowerCase()
                                && data.data[0].lastName.toLowerCase() == scope.lastName.toLowerCase()
                                && data.data[0].primaryPhoneNumber == scope.phoneNumber
                                && data.data[0].primaryPhoneNumberCountryCode == scope.countryCode
                            ) {
                                //not unique
                                var customOptions: Meevo.Components.Modal.ILocalOptions = {
                                    showCancelButton: true,
                                    cancelButtonContentKey: "LABEL_NO_GO_TO_EXISTING_PROFILE"
                                };

                                modalService.confirm("WARNING_DUPLICATE_CLIENT_PHONE",
                                    Modal.ModalTranslationModes.Translate,
                                    false,
                                    customOptions,
                                    true)
                                    .then((response: boolean) => {
                                        if (!response) {
                                            // if user clicks on negative action
                                            scope.abortAction({ existingClientId: data.data[0].id });
                                        }
                                    });
                            }
                        }).finally(() => {
                            if (scope.context) {
                                scope.context[scope.flagPropName] = false;
                            }
                        });

                    if (scope.context) {
                        scope.context[scope.flagPropName] = true;
                    }

                }
            }
        }

        constructor(private modalService: Meevo.Components.Modal.IModalService,
                    private appSettings: Meevo.Components.Common.IAppSettings,
                    private dataService: Meevo.Components.BaseClasses.IDataService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (modalService: Meevo.Components.Modal.IModalService,
                             appSettings: Meevo.Components.Common.IAppSettings,
                             dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoPhoneNumberWarning(modalService, appSettings, dataService);
            }

            directive.$inject = ["meevo.components.modal.ModalService", "meevo.AppSettings", "meevo.components.common.DataService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPhoneNumberWarning", MeevoPhoneNumberWarning.factory());

}